import { Waypoint } from "@/api.types";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth0/session";

/**
 * Hook to fetch a specific waypoint for a trip
 */
export function useWaypointById(tripId: string, waypointId: string) {
  const { token } = useSession();

  return useQuery<Waypoint>({
    queryKey: ["waypoints", tripId, waypointId],
    queryFn: async () => {
      const { data } = await axios.get<Waypoint>(
        `${import.meta.env.VITE_API_URL}/api/v1/trips/${tripId}/waypoints/${waypointId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    },
    enabled: !!token && !!tripId && !!waypointId,
  });
}
